import apiClient from '../config/axiosConfig'; 


export const getProfileFromAPI = () => {
    return apiClient.get('/v2/profiles/me');
};
